export const ErrorsConstant = {
    NetworkIssue: 'Check your internet connection and try again',
    ClientSide: 'Woops !! Your request could not be processed. Please try again later',
    ServerSide: 'Sorrry !! Server encountered a temporary error. Pleae try again after sometime'
}